import { render, staticRenderFns } from "./SubalcanceRendererColor.vue?vue&type=template&id=b04451c8"
import script from "./SubalcanceRendererColor.vue?vue&type=script&lang=js"
export * from "./SubalcanceRendererColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports